import React, { FC } from "react";
import CN from "classnames";
import ImageUpload, { Image } from "../plugins/ImageUpload";
import { useFormik } from "formik";
import * as Yup from "yup";
import store from "../../../store/store";
import { Oval } from "react-loader-spinner";
import { Button } from "../../../components/Button";
import { useSelector } from "react-redux";
import { updateBanner } from "../reducer/bannerSlice";
import DeleteLink from "../../../components/Popup/DeleteLink";

interface FormValues {
  title: string;
  offer: string;
  priority: string;
  file?: File | null;
}
const EditBanner: FC<any> = ({ item }) => {
  const { isLoading } = useSelector((state: any) => state.rootReducer.banner);
  const { fullResponse } = useSelector(
    (state: any) => state.rootReducer.offers
  );

  const validationSchema = Yup.object({
    title: Yup.string(),
    offers: Yup.string(),
    priority: Yup.string(),
    // file: Yup.mixed(),
  });

  const {
    handleSubmit,
    handleChange,
    handleBlur,
    setFieldValue,
    values,
    errors,
    touched,
  } = useFormik<FormValues>({
    initialValues: {
      title: item?.title ?? "",
      offer: item?.offers?._id ?? "",
      priority: item?.priority ?? "",
      file: null,
    },
    validationSchema,
    onSubmit: (values) => {
      const formData = new FormData();
      Object.entries(values).forEach(([key, value]) => {
        if (key === "file") {
          if (value) {
            formData.append("file", value as File);
          }
        } else if (Array.isArray(value)) {
          value.forEach((val) => formData.append(`${key}[]`, val));
        } else {
          formData.append(key, value as string);
        }
      });
      console.log("formData", formData);
      const data = {
        id: item?._id,
        data: formData,
      };
      // addProductContext?.addNewProduct(formData);
      console.log("data", data);
      store.dispatch(updateBanner(data));
    },
  });
  const handleImageUpload = (image: File | Image | null) => {
    setFieldValue("file", image);
  };

  return (
    <div className="flex flex-col justify-between p-2 space-y-3 border-2 rounded-md">
      <img src={item?.imageLink} className="w-full" alt="" />
      <form onSubmit={handleSubmit} className="space-y-3">
        <div className="col-span-1">
          <label className="block text-base font-semibold mb-2">
            Banner <span className="text-red-500">*</span>
          </label>
          <ImageUpload onUpload={handleImageUpload} />
          {errors.file && touched.file && (
            <p className="text-red-500 text-sm my-2">{errors.file}</p>
          )}
        </div>
        <div className="col-span-1">
          <label className="block text-base font-semibold mb-2">Title</label>
          <input
            type="text"
            name="title"
            value={values.title}
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder="Title"
            className={CN(
              "block w-full p-3 border rounded-md",
              errors.title && touched.title
                ? "border-red-500"
                : "border-primary1"
            )}
          />
          {errors.title && touched.title && (
            <p className="text-red-500 text-sm my-2">{errors.title}</p>
          )}
        </div>
        {/* <div className="col-span-1">
          <div className="flex flex-col gap-1 mb-2">
            <label className="block text-base font-semibold">Banner Type</label>
          </div>
          <select
            name="priority"
            value={values.priority}
            onChange={handleChange}
            onBlur={handleBlur}
            className={CN(
              "block w-full p-3 border rounded-md",
              errors.priority && touched.priority
                ? "border-red-500"
                : "border-primary1"
            )}
          >
            <option value="" disabled hidden>
              Select Banners
            </option>
            <option value={1}>Main Banner</option>
            <option value={2}>Middle Banner</option>
            <option value={3}>Bottom Banner</option>
          </select>
          {errors.priority && touched.priority && (
            <p className="text-red-500 text-sm my-2">{errors.priority}</p>
          )}
        </div> */}

        <div className="col-span-1">
          <div className="flex flex-col gap-1 mb-2">
            <label className="block text-base font-semibold">Offers</label>
          </div>
          {`${item?.offers?.name} - ${item?.offers?.discountPrecentage}%`}
          <select
            name="offer"
            value={values.offer}
            onChange={handleChange}
            onBlur={handleBlur}
            className={CN(
              "block w-full p-3 border rounded-md",
              errors.offer && touched.offer
                ? "border-red-500"
                : "border-primary1"
            )}
          >
            <option value="" disabled hidden>
              Select Discount
            </option>
            {fullResponse?.map((item: any, index: number) => (
              <option
                key={index}
                value={item._id}
              >{`${item?.name} - ${item?.discountPrecentage}%`}</option>
            ))}
            {/* <option value={1}>Main Banner</option>
              <option value={2}>Middle Banner</option>
              <option value={3}>Bottom Banner</option> */}
          </select>
          {errors.offer && touched.offer && (
            <p className="text-red-500 text-sm my-2">{errors.offer}</p>
          )}
        </div>
        <Button
          isLoading={isLoading.updateBanners}
          view="default"
          type="submit"
          size="lg"
        >
          <div className="flex gap-1">
            {isLoading.updateBanners && (
              <Oval
                height={18}
                width={18}
                color="#ffff"
                wrapperStyle={{}}
                wrapperClass="max-sm:mt-[3.5px] mt-[5.2px] max-lg:mt-[5.2px]"
                visible={true}
                ariaLabel="oval-loading"
                secondaryColor="gray-primary"
                strokeWidth={6}
                strokeWidthSecondary={6}
              />
            )}
            <div className="font-normal text-base">Update</div>
          </div>
        </Button>
      </form>
      <DeleteLink entityType="banner" entityData={item?._id} />
    </div>
  );
};

export default EditBanner;
